import { KanbanLane } from './KanbanLane';

import type { BoardLanes, LaneKey } from '@/types/board.types';

const LANE_ORDER: LaneKey[] = [
  'submitted',
  'videoPending',
  'videoCompleted',
  'underReview',
  'approved',
  'waitlist',
  'rejected',
];

interface KanbanBoardProps {
  lanes: BoardLanes;
  onCardClick: (id: string) => void;
}

export function KanbanBoard({ lanes, onCardClick }: KanbanBoardProps) {
  return (
    <div className='flex gap-4 overflow-x-auto pb-4'>
      {LANE_ORDER.map((key: LaneKey) => (
        <KanbanLane key={key} laneKey={key} cards={lanes[key]} onCardClick={onCardClick} />
      ))}
    </div>
  );
}
